import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { CreatorTable, Creator } from '../components/CreatorTable';
import { ArrowLeft, Plus, Search, Filter } from 'lucide-react';
const mockCreators: Creator[] = [{
  id: '1',
  name: 'Sarah Klein',
  handle: 'sarah.style',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=800',
  followers: 245000,
  engagement: 3.2,
  growth: 2.4,
  status: 'active'
}, {
  id: '2',
  name: 'Tom Weber',
  handle: 'tom_travels',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800',
  followers: 89000,
  engagement: 5.8,
  growth: 12.5,
  status: 'growing'
}, {
  id: '3',
  name: 'Lisa Schmidt',
  handle: 'lisa.fitness',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=800',
  followers: 156000,
  engagement: 4.1,
  growth: -0.5,
  status: 'stable'
}, {
  id: '4',
  name: 'Felix Meyer',
  handle: 'felix_tech',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=800',
  followers: 42000,
  engagement: 6.2,
  growth: 8.9,
  status: 'growing'
}, {
  id: '5',
  name: 'Emma Wilson',
  handle: 'emma.eats',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800',
  followers: 310000,
  engagement: 2.8,
  growth: 1.1,
  status: 'active'
}, {
  id: '6',
  name: 'David Brown',
  handle: 'david.photo',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800',
  followers: 12000,
  engagement: 8.5,
  growth: 15.2,
  status: 'growing'
}, {
  id: '7',
  name: 'Sophie Miller',
  handle: 'sophie_art',
  avatar: 'https://images.unsplash.com/photo-1554151228-14d9def656ec?w=800',
  followers: 78000,
  engagement: 4.5,
  growth: 0.2,
  status: 'stable'
}, {
  id: '8',
  name: 'James Wilson',
  handle: 'james.gym',
  avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=800',
  followers: 195000,
  engagement: 3.9,
  growth: -1.2,
  status: 'active'
}];
export function CreatorsPage() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState<'all' | Creator['status']>('all');
  const filteredCreators = mockCreators.filter(creator => {
    const matchesSearch = creator.name.toLowerCase().includes(searchQuery.toLowerCase()) || creator.handle.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = statusFilter === 'all' || creator.status === statusFilter;
    return matchesSearch && matchesStatus;
  });
  return <div className="min-h-screen bg-gray-50 pb-12" data-id="element-889">
      <header className="bg-white border-b sticky top-0 z-10" data-id="element-890">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-891">
          <div className="flex items-center" data-id="element-892">
            <Button variant="ghost" size="sm" className="mr-4" onClick={() => navigate('/manager')} data-id="element-893">
              <ArrowLeft className="h-4 w-4 mr-2" data-id="element-894" /> Back
            </Button>
            <h1 className="text-xl font-bold text-gray-900" data-id="element-895">Creators</h1>
          </div>
          <Button variant="primary" size="sm" className="bg-blue-600 hover:bg-blue-700" data-id="element-896">
            <Plus className="h-4 w-4 mr-2" data-id="element-897" /> Add Creator
          </Button>
        </div>

        {/* Tabs */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-898">
          <div className="flex space-x-8 -mb-px" data-id="element-899">
            <button onClick={() => navigate('/manager')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-900">
              Overview
            </button>
            <button className="pb-4 text-sm font-medium text-blue-600 border-b-2 border-blue-600" data-id="element-901">
              Creators
            </button>
            <button onClick={() => navigate('/manager/brands')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-902">
              Brands
            </button>
            <button onClick={() => navigate('/manager/projects')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-903">
              Projects
            </button>
            <button onClick={() => navigate('/manager/tasks')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-904">
              Tasks
            </button>
            <button onClick={() => navigate('/manager/platforms')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-905">
              Platforms
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-906">
        {/* Search & Filters */}
        <div className="flex items-center justify-between mb-6" data-id="element-907">
          <div className="flex items-center space-x-4 flex-1 max-w-2xl" data-id="element-908">
            <div className="relative flex-1" data-id="element-909">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" data-id="element-910" />
              <Input type="text" placeholder="Search creators by name or handle..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-10" data-id="element-911" />
            </div>
            <div className="flex items-center space-x-2" data-id="element-912">
              <Button variant={statusFilter === 'all' ? 'secondary' : 'ghost'} size="sm" onClick={() => setStatusFilter('all')} data-id="element-913">
                All
              </Button>
              <Button variant={statusFilter === 'active' ? 'secondary' : 'ghost'} size="sm" onClick={() => setStatusFilter('active')} data-id="element-914">
                Active
              </Button>
              <Button variant={statusFilter === 'growing' ? 'secondary' : 'ghost'} size="sm" onClick={() => setStatusFilter('growing')} data-id="element-915">
                Growing
              </Button>
              <Button variant={statusFilter === 'stable' ? 'secondary' : 'ghost'} size="sm" onClick={() => setStatusFilter('stable')} data-id="element-916">
                Stable
              </Button>
            </div>
          </div>
          <div className="flex items-center text-sm text-gray-500" data-id="element-917">
            <Filter className="h-4 w-4 mr-2" data-id="element-918" /> {filteredCreators.length}{' '}
            Creators
          </div>
        </div>

        {/* Creators Table */}
        <CreatorTable creators={filteredCreators} data-id="element-919" />
      </main>
    </div>;
}